import {Provider} from 'globx-react';
import * as React from 'react';
import * as DOM   from 'react-dom';
import {Subject}  from 'rxjs';

import IPlayer                from '../../Player/Interfaces/IPlayer';
import IUi                    from '../Shared/Interfaces/IUi';
import IUiEventsStreamPayload from '../Shared/Interfaces/IUiEventsStreamPayload';

import Frame from './Components/Frame';

class Browser implements IUi {
    public uiEvents$ = new Subject<IUiEventsStreamPayload>();

    private player: IPlayer;
    private isMounted: boolean = false;

    constructor(player: IPlayer) {
        this.player = player;
    }

    public mount(): void {
        if (this.isMounted) return;

        DOM.render(
            <Provider stores={this.player.state.stores}>
                <Frame uiEvents$={this.uiEvents$}/>
            </Provider>,
            this.player.refs.ui
        );

        this.isMounted = true;
    }

    public unmount(): void {
        DOM.unmountComponentAtNode(this.player.refs.ui);
    }
}

export default Browser;